import { FC, Fragment } from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { GasIcon } from "../core/icons/Icons";
import { NumberInput } from "../core/NumberField";
import { Switch } from "../core/Switch";
import { Colors } from "../../styles";
import { useStyles } from "../../useStyles";
import { createStyles, makeStyles, InputLabel } from "@material-ui/core";

const textStyles = makeStyles(() =>
    createStyles({
        pText: {
            color: Colors.anthracite,
            fontStretch: "normal",
            fontFamily: "innogyWEB",
            fontSize: 22,
            fontWeight: 300,
            fontStyle: "normal",
            lineHeight: 1.27,
            letterSpacing: "normal",
        },
    }),
);

export const IncreaseExpectedGasDemandForm: FC = () => {
    const classes = useStyles();
    const classes2 = textStyles();
    const { values, setValues, getFieldProps } =
        useFormModel<ChangeNames.INCREASE_EXPECTED_GAS_DEMAND>();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<GasIcon />}
                useSwitch={
                    <Switch
                        checked={values.increaseExpectedGasDemand.value.installed}
                        {...getFieldProps("adjustableLoadElectricBoiler.value.installed")}
                        onChange={(e, checked) =>
                            setValues((values) => {
                                values.increaseExpectedGasDemand.value.installed = checked;
                                values.increaseExpectedGasDemand.value.demand.amount = checked
                                    ? 0
                                    : null;
                            })
                        }
                    />
                }
                detailCondition={values.increaseExpectedGasDemand.value.installed}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Gasnennwärmeleistung
                        </p>
                        <p className={classes2.pText} style={{ marginTop: 0, marginBottom: 24 }}>
                            Geben Sie die Gasnennwärmeleistung an. Die benötigte Leistung erhalten
                            Sie ggf. von Ihrem Heizungsinstallateur/Architekten.
                        </p>
                    </Fragment>
                }
                detail={
                    <Fragment>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Gasnennwärmeleistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            fixedDecimalScale={false}
                            allowLeadingZeros={false}
                            decimalScale={values.increaseExpectedGasDemand.value.demand.precision}
                            isNumericString={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.increaseExpectedGasDemand.value.demand.unit}
                            value={values.increaseExpectedGasDemand.value.demand.amount || ""}
                            placeholder="0"
                            onValueChange={(v) =>
                                setValues((values) => {
                                    values.increaseExpectedGasDemand.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.increaseExpectedGasDemand.error !== null}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
